export default __webpack_public_path__ + "static/media/shipvistaIcon.73d30ba8.png";